import { render, staticRenderFns } from "./Yearly.vue?vue&type=template&id=35408e04&"
import script from "./Yearly.vue?vue&type=script&lang=js&"
export * from "./Yearly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports